import { ApiClient } from 'src/api/axiosClient'
import {
  IBannerBottom,
  IBannerTop,
} from 'src/components/evolve-landing-page-management/banner/bannerSchema'
import { IDownload } from 'src/components/evolve-landing-page-management/download/downloadSchema'
import {
  IAddFeatureRequest,
  IFeatureDetail,
} from 'src/components/evolve-landing-page-management/feature/FeatureDetailModal'
import { IJoinOurCommunitySchema } from 'src/components/evolve-landing-page-management/joinOurCommunity/JoinOurCommunitySchema'
import { IMemberUse } from 'src/components/evolve-landing-page-management/memberUse/memberUseSchema'
import { IEvolveSeoPageSchema } from 'src/components/evolve-landing-page-management/seoConfig/seoConfigSchema'
import {
  IAddPostRequest,
  IEvolveBannerData,
  IEvolveCommunity,
  IEvolveDownloadData,
  IEvolveMemberUseItem,
  IHeadingContent,
  IHeadingContentRes,
  IHeadingType,
  ILibraryItem,
  ISeoEvolve,
} from 'src/interfaces/evolve-landing-management'

const baseUrl = '/common-contents/'

export const evolveLandingManagementAPI = {
  // banner
  createBannerTop: async (body: IBannerTop) => {
    return await ApiClient.post<{ commonContent: IEvolveBannerData }>(
      `${baseUrl}evolve-banner/top`,
      body
    )
  },
  getBannerTop: async () => {
    return await ApiClient.get<IEvolveBannerData>(`${baseUrl}evolve-banner/top`)
  },
  createBannerBottom: async (params: IBannerBottom) => {
    return await ApiClient.post<{ commonContent: IEvolveBannerData }>(
      `${baseUrl}evolve-banner/bottom`,
      params
    )
  },
  getBannerBottom: async () => {
    return await ApiClient.get<IEvolveBannerData>(
      `${baseUrl}evolve-banner/bottom`
    )
  },
  // evolve features
  getEvolveFeatureList: async () => {
    return await ApiClient.get<IFeatureDetail[]>(`${baseUrl}evolve-feature`)
  },
  getEvolveFeatureById: async (id: number) => {
    return await ApiClient.get<IFeatureDetail>(`${baseUrl}evolve-feature/${id}`)
  },
  createEvolveFeature: async (params: IAddFeatureRequest) => {
    return await ApiClient.post<{
      evolveFeature: IFeatureDetail
      message: string
    }>(`${baseUrl}evolve-feature`, params)
  },
  updateEvolveFeature: async (id: number, params: IAddFeatureRequest) => {
    return await ApiClient.put<{
      evolveFeature: IFeatureDetail
      message: string
    }>(`${baseUrl}evolve-feature/${id}`, params)
  },
  deleteEvolveFeature: async (id: number) => {
    return await ApiClient.delete<{ message: string }>(
      `${baseUrl}evolve-feature/${id}`
    )
  },

  // evolve download
  getEvolveDownload: async () => {
    return await ApiClient.get<IEvolveDownloadData>(`${baseUrl}evolve-download`)
  },
  createEvolveDownload: async (params: IDownload) => {
    return await ApiClient.post<{
      commonContent: IEvolveDownloadData
      message: string
    }>(`${baseUrl}evolve-download`, params)
  },
  //member use
  getMemberUseList: async () => {
    return await ApiClient.get<IEvolveMemberUseItem[]>(
      `${baseUrl}evolve-member-use`
    )
  },
  createMemberUse: async (params: IMemberUse) => {
    return await ApiClient.post(`${baseUrl}evolve-member-use`, params)
  },
  updateMemberUseById: async (params: Partial<IMemberUse>, id: string) => {
    return await ApiClient.put<IEvolveMemberUseItem[]>(
      `${baseUrl}evolve-member-use/${id}`,
      params
    )
  },
  deleteMemberUse: async (id: string) => {
    return await ApiClient.delete(`${baseUrl}evolve-member-use/${id}`)
  },
  getHeadingContent: async (type: IHeadingType) => {
    return await ApiClient.get<IHeadingContentRes>(`${baseUrl}heading`, {
      params: { type },
    })
  },
  changeHeadingContent: async (body: IHeadingContent, type: IHeadingType) => {
    return await ApiClient.post(`${baseUrl}heading?type=${type}`, body)
  },
  //library
  getLibraryDetail: async () => {
    return await ApiClient.get<{ evolveLibrary: ILibraryItem }>(
      `${baseUrl}evolve-library`
    )
  },
  addPostToLibrary: async (body: { posts: IAddPostRequest[] }) => {
    return await ApiClient.post<{ evolveLibrary: ILibraryItem }>(
      `${baseUrl}evolve-library`,
      body
    )
  },
  //seo
  getEvolvePageSeo: async () => {
    return await ApiClient.get<ISeoEvolve>(`${baseUrl}seo-evolve-page`)
  },
  updateEvolvePageSeo: async (body: IEvolveSeoPageSchema) => {
    return await ApiClient.post<{ commonContent: ISeoEvolve }>(
      `${baseUrl}seo-evolve-page`,
      body
    )
  },
  //our community
  getEvolveOurCommunity: async () => {
    return await ApiClient.get<IEvolveCommunity>(`${baseUrl}evolve-community`)
  },
  createEvolveOurCommunity: async (params: IJoinOurCommunitySchema) => {
    return await ApiClient.post<{
      commonContent: IEvolveCommunity
      message: string
    }>(`${baseUrl}evolve-community`, params)
  },
}
